<template lang="html">
    <div class="common-select">
        <input type="hidden" v-bind:value="innerValue" />
        <div class="common-select-title"><span @click="handleSelectClick" v-html="titleStr"></span><common-tooltip v-if="!!tipCode" :tipCode="tipCode"></common-tooltip><span class="not-required" :class="required?'required':''">*</span></div>
        <div :class="['common-select-infos',alignRight?'common-select-infos-align-right':'']" @click="handleSelectClick">
            <div class="common-select-text">{{currentText}}<span class="value-special-text" v-if="valueObj && valueObj[specialTextKey]">{{valueObj[specialTextKey]}}</span></div>
            <div class="common-select-placeholder" v-show="!currentText">{{placeholder}}</div>
            <div :class="'common-select-dropdown-icon-'+iconType"></div>
        </div>
        <mt-popup
            v-model="popupVisible"
            position="bottom"
            class="common-select-options">
            <mt-picker class="common-select-options-picker" ref="picker" :slots="slots" @change="handleValuesChange" showToolbar :value-key="textKey" :class="(selectObj && selectObj.disabled)?'disabled':''">
                <div class="common-select-options-toolbar">
                    <span v-if="selectObj && selectObj[specialTextKey]" class="special-text">{{selectObj[specialTextKey]}}</span>
                    <mt-button v-if="clearable && innerValue" @click="handleCancleClick" type="default" size="small" class="common-select-options-toolbar-cancel-btn cancel-btn">清除</mt-button>
                    <input v-if="filterable" class="search-input" type="search" :placeholder="'输入搜索内容'" v-model="searchText" />
                    <mt-button @click="handleComfirmClick" type="primary" size="small" class="common-select-options-toolbar-confirm-btn" :disabled="(selectObj && selectObj.disabled)">确定</mt-button>
                </div>
            </mt-picker>
        </mt-popup>
    </div>
</template>

<script>
import { Popup, Picker } from 'mint-ui';
  export default {
    props: {
        'title': {
            type: String,
            required: false
        },
        'titleArray': {
            type: Array,
            required: false
        },
        'placeholder': {
            type: String,
            required: false
        },
        'datas': {
            required: true
        },
        'valueKey': {
            type:String,
            required: true
        },
        'textKey': {
            type:String,
            required: true
        },
        'specialTextKey': {
            type:String,
            required: false,
            default: ''
        },
        'alignRight': {
            type:Boolean,
            required: false,
            default:false,
        },
        'value': {

        },
        'clearable': {
            type:Boolean,
            required: false,
            default:false,
        },
        'defaultValue': {
            type:String,
            required: false,
            default: '',
        },
        'required': {
            type:Boolean,
            required: false,
            default: false,
        },
        'tipCode': {
            required: false
        },
        'iconType': {
            type: String,
            required: false,
            default:'arrow'
        },
        'filterable': {
            type:Boolean,
            required: false,
            default: false,
        },
    },
    event: 'change',
    components: {
        Popup,
        Picker,
    },
    data() {
        return {
            popupVisible: false,
            slots: [
                {            
                    values: [],
                    defaultIndex: 0
                },
            ],
            selectObj: null,
            valueObj: null,
            searchText: '',
            selectIndex: 0,
        };
    },
    computed: {
        titleStr() {
            if(this.title) {
                return this.title;
            }
            
            if(this.titleArray) {
                return this.titleArray.join('<br/>');
            }

            return ''
        },
        currentText() {
            if(!this.value || !this.datas){
                return this.defaultValue;
            }

            let text = '';
            this.datas.forEach(element => {
                if(element[this.valueKey] == this.value){
                    text = element[this.textKey];
                }
            });

            return text;
        },
        innerValue: {
            get() {
               return this.value 
            },
            set(val) {
                 this.$emit('input', val) //这里多用于子组件间没有input元素中,通过在computed属性中监听值变化事emit input事件
            }
        }
    },
    methods: {   
        getSelectIndex() {
            let di = 0;
            if(this.datas){
                var this$1 = this;
                this.datas.forEach((element,index) => {
                    if(element[this$1.valueKey] == this$1.value) {
                        di = index;
                    }
                })
            }

            return di;
        },
        handleSelectClick() {
            this.popupVisible = true;
            this.searchText = ''
            this.$nextTick(() => {          
                this.slots[0].defaultIndex = this.selectIndex;
            })
        },
        handleValuesChange(picker, values) {
            this.selectObj = values[0];
            this.selectIndex = this.getSelectIndex();
            this.$nextTick(() => {          
                this.slots[0].defaultIndex = this.selectIndex;
            })
        },
        handleCancleClick() {
            this.innerValue = '';
            this.selectObj = this.datas[0];
            this.$refs.picker.setValues([this.selectObj])
            
            this.popupVisible = false;

            this.valueObj = this.selectObj;

            this.$emit('change');
        },
        handleComfirmClick() {
            if(this.selectObj[this.valueKey].toString() != this.value) {
                if(this.selectObj) {
                    this.innerValue = this.selectObj[this.valueKey].toString();
                }
                this.popupVisible = false;

                this.valueObj = this.selectObj;

                this.$emit('change');
            }
            else {
                this.popupVisible = false;
            }
        },
        initSlotData(query) {
            let tempDatas = null;

            if(this.datas){

                tempDatas = [];

                this.datas.forEach(el => {
                    if(query) {
                        if(!el[this.textKey] || !el[this.valueKey]) {
                            return;
                        }

                        if(el[this.textKey].toLowerCase().indexOf(query.toLowerCase()) < 0 && el[this.valueKey].toLowerCase().indexOf(query.toLowerCase()) < 0) {
                            return;
                        }
                    }

                    tempDatas.push(el)
                })

                for (let index = 0; index < this.datas.length; index++) {
                    const element = this.datas[index];
                    if(element[this.valueKey] == this.value) {
                        this.slots[0].defaultIndex = index;
                    }
                }
            }

            this.slots[0].values = tempDatas;
        }
    },
    watch: {
        datas() {
            this.initSlotData();
        },
        value() {
            this.innerValue = this.value;
            if(this.datas){
                this.selectObj = this.datas[0];
                
                for (let index = 0; index < this.datas.length; index++) {
                    const element = this.datas[index];
                    if(element[this.valueKey] == this.value) {
                        this.selectObj = element;
                    }
                }

                this.valueObj = this.selectObj;
            
                this.$refs.picker.setValues([this.selectObj])
            }
        },
        searchText() {
            this.initSlotData(this.searchText);
        },
    },
    mounted: function() {
        this.initSlotData()
    }
  };
</script>

<style lang="less" scoped>
    .common-select {
        display: flex;
        min-height: 24px;
        font-size: 14px;

        &-title {
            line-height: 24px;
        }

        &-dropdown-icon-trigle {
            width: 0;
            height: 0;
            border-left: 6px solid transparent; //左边宽度50px，实线，透明颜色
            border-right: 6px solid transparent; //右边同上
            border-top: 6px solid #999999;
            margin-top: 9px;
            margin-left: 7px;
        }

        &-dropdown-icon-arrow {
            width: 9px;
            height: 9px;
            margin-top: 7px;
            border-top: 1px solid #999999;
            border-right: 1px solid #999999;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            margin-left: 4px;
        }

        &-text {
            min-height: 24px;
            line-height: 24px;
            max-width: 200px;
        }

        &-infos {
            display: flex;

            &-align-right {
                    margin-left: auto;
                    padding-right: 20px;
            }
        }

        &-placeholder {
            color: #999999;
            line-height: 24px;
        }

        &-options {
            &-toolbar {
                padding: 5px 15px 0 15px;

                &-cancel-btn {
                    float: left;
                }

                &-confirm-btn {
                    float: right;
                }

                .search-input {
                    height: 35px;
                    width: 220px;
                    position: absolute;
                    right: 80px;
                    border: 1px solid #dfdfdf;
                    padding: 0 10px;
                    border-radius: 4px;
                }
            }
        }        

        .not-required {
            display: none;
        }
        
        .required {
            display: inline;
            color: #E64100;
            margin-left: 5px;
        }
    }
</style>


// WEBPACK FOOTER //
// CommonSelect.vue?2aeaf346